import { RefObject, useCallback, useEffect, useState } from 'react';

export function useIntersectOnce(
    elementRef: RefObject<HTMLElement | null>,
    options?: IntersectionObserverInit,
) {
    const [hasIntersected, setHasIntersected] = useState(false);

    const handleIntersect: IntersectionObserverCallback = useCallback(
        function (entries, observer) {
            if (entries.length > 0 && entries[0].isIntersecting) {
                setHasIntersected(true);
                observer.disconnect();
            }
        },
        [setHasIntersected],
    );

    useEffect(() => {
        const observer = new IntersectionObserver(handleIntersect, options);

        if (elementRef.current) {
            observer.observe(elementRef.current);
        }

        return () => {
            observer.disconnect();
        };
    }, [elementRef, handleIntersect, options]);

    return hasIntersected;
}
